import React from 'react';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import PrivacyMain from './PrivacyMain';
import BackToTop from '../../components/elements/BackToTop';

const Privacy = () => {
    return (
        <React.Fragment>
            <Header />
            <PrivacyMain />
            <Footer />
            <BackToTop />
        </React.Fragment>
    );
}

export default Privacy;